import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex py-2 align-items-center" }
const _hoisted_2 = { class: "document__name__status col-6 d-flex flex-column flex-md-row align-items-center" }
const _hoisted_3 = { class: "document-name body-strong text-grey-900 col-12" }
const _hoisted_4 = { class: "document-status caption text-grey-900 col-12" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  class: "download-text"
}
const _hoisted_7 = { class: "download-icon" }

import { computed, ComputedRef } from 'vue'

  // Types
  import { Document } from '@/services/DocumentsService.interface'

  // Icons
  import DownloadIcon from '@/assets/DownloadIcon.vue'

  // Translations
  import { useI18n } from 'vue-i18n'

  interface Props {
    document: Partial<Document>
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Document',
  props: {
    document: {}
  },
  setup(__props: any) {

  const { t } = useI18n()

  // Props
  const props = __props

  // Computed
  const isAvailable: ComputedRef<boolean> = computed(() => {
    return !!props.document.fileLink
  })

  // Display name: use label for "other" type, otherwise use translated document type
  const displayName: ComputedRef<string> = computed(() => {
    if (props.document.documentType === 'other' && props.document.label) {
      return props.document.label
    }
    return t(`documents.${props.document.documentType}`)
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(displayName.value), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)(`documents.${_ctx.document.documentType}-available`)), 1)
    ]),
    _createElementVNode("a", {
      class: _normalizeClass(["document-download d-flex align-items-center gap-1 col-6 link-small justify-content-end", isAvailable.value ? 'cursor-pointer' : 'disabled']),
      href: props.document.fileLink || '#',
      target: "_blank"
    }, [
      (isAvailable.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(t)('documents.download')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(DownloadIcon)
      ])
    ], 10, _hoisted_5)
  ]))
}
}

})